'use strict';

/**
 * @fileoverview Show dialog on canvas
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.Reporter = /*#__PURE__*/function () {
  function Reporter(isRealTime) {
    (0, _classCallCheck2["default"])(this, Reporter);
    this.userId = null;
    this.projectId = null;
    this.isRealTime = isRealTime;
    this.activities = [];
  }
  return (0, _createClass2["default"])(Reporter, [{
    key: "start",
    value: function start(projectId, userId, startTime) {
      //this.io = io(window.location.href.split("/")[2]);
      if (this.isRealTime) {
        if (window.location.href.indexOf('localhost') > -1) {
          this.io = io('localhost:7000');
        } else {
          this.io = io('play04.play-entry.com:7000');
        }
        this.io.emit('activity', {
          message: 'start',
          userId: userId,
          projectId: projectId,
          time: startTime
        });
      }
      this.userId = userId;
      this.projectId = projectId;
    }
  }, {
    key: "report",
    value: function report(state) {
      if (this.isRealTime && !this.io) {
        return;
      }
      var params = [];
      for (var i in state.params) {
        var param = state.params[i];
        if ((0, _typeof2["default"])(param) !== 'object') {
          params.push(param);
        } else if (param.id) {
          params.push(param.id);
        }
      }
      var activity = {
        message: state.message,
        userId: this.userId,
        projectId: this.projectId,
        time: state.time,
        params: params
      };
      if (this.isRealTime) {
        this.io.emit('activity', activity);
      } else {
        this.activities.push(activity);
      }
    }
  }]);
}();